import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    formControl: {
      margin: theme.spacing(1)
    },
    marginLeft: {
      marginLeft: theme.spacing(1)
    },
    ageRuleBtn: {
      maxWidth: 130,
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    dialogHeaderFooter: {
      background: colors.defaultGrey
    },
    dialog: {
      overflow: 'hidden'
    },
    updateForm: {
      minWidth: 250,
      justifyContent: 'center'
    },
    sectionTitle: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      fontWeight: 'bold'
    }
  });
});
